import { render } from "./MedicalNotesTable.vue?vue&type=template&id=83caf0e6"
import script from "./MedicalNotesTable.vue?vue&type=script&lang=js"
export * from "./MedicalNotesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__